import(/* webpackMode: "eager" */ "/app/src/app/hinh-anh/page.js");
